import { Link } from 'react-router-dom';
import { Gift, Trophy } from 'lucide-react';
import { EmptyState, ErrorState, Skeleton, SubBar } from '@/design/components';
import { formatDate } from '@/lib/dates';
import { useMyPoints } from './api';

/** הנקודות שלי: יתרה, ומאיפה היא הגיעה (PRD 5.8.1). */
export function PointsPage() {
  const points = useMyPoints();

  if (points.isPending) return <Skeleton className="m-4 h-40" />;
  if (points.isError) return <ErrorState onRetry={() => void points.refetch()} />;

  const data = points.data ?? { balance: 0, earned_this_month: 0, history: [] };

  return (
    <div className="grid content-start gap-4">
      <SubBar title="הנקודות שלי" subtitle="מה צברת, ועל מה" />

      <div className="grid gap-4 px-4 pb-8">
        <div className="grid gap-1 rounded-lg bg-raised p-4 shadow-card">
          <span className="text-body-sm text-muted">היתרה שלך</span>
          <span className="font-display text-stat font-bold tabular">{data.balance}</span>
          {data.earned_this_month > 0 && (
            <span className="text-body-sm text-muted">
              צברת {data.earned_this_month} נקודות החודש
            </span>
          )}
        </div>

        <div className="grid gap-2 sm:grid-cols-2">
          <Link
            to="/rewards"
            className="flex items-center gap-2 rounded-md border border-line bg-raised p-3 text-body font-medium text-ink no-underline"
          >
            <Gift size={20} strokeWidth={1.75} aria-hidden="true" />
            חנות הפרסים
          </Link>
          <Link
            to="/leaderboard"
            className="flex items-center gap-2 rounded-md border border-line bg-raised p-3 text-body font-medium text-ink no-underline"
          >
            <Trophy size={20} strokeWidth={1.75} aria-hidden="true" />
            טבלת המובילים
          </Link>
        </div>

        <section className="grid gap-2">
          <h2 className="m-0 font-display text-display-m font-semibold">ההיסטוריה</h2>

          {data.history.length === 0 ? (
            <EmptyState
              title="עוד לא צברת נקודות"
              description="נקודות מגיעות מלומדות, חידונים ואישור קריאה של הודעות."
            />
          ) : (
            <ul className="m-0 grid list-none gap-2 p-0">
              {data.history.map((entry) => (
                <li
                  key={entry.id}
                  className="flex items-center gap-3 rounded-md border border-line bg-raised p-3"
                >
                  <span className="grid min-w-0 grow gap-0.5">
                    <span className="truncate text-body text-ink">{entry.reason}</span>
                    <span className="text-label text-muted">
                      {formatDate(entry.created_at)}
                      {entry.granted_by && ` · ${entry.granted_by}`}
                    </span>
                  </span>
                  {/* מינוס וצבע יחד, לא צבע לבד (מערכת העיצוב) */}
                  <span
                    className={`shrink-0 text-title font-medium tabular ${
                      entry.points < 0 ? 'text-bad' : 'text-good'
                    }`}
                  >
                    {entry.points > 0 ? `+${entry.points}` : entry.points}
                  </span>
                </li>
              ))}
            </ul>
          )}
        </section>
      </div>
    </div>
  );
}
